import React from "react";

import { inject, observer, Provider } from "mobx-react";
import { PermissionsController } from "./PermissionsController";
import { PermissionsContainer } from "./PermissionsContainer";

import "./PermissionsStyles.scss";

@inject("store")
@observer
export class Permissions extends React.Component<any> {
  store: any;

  private permissionsController = null;

  constructor(props) {
    super(props);
    this.store = props.store;
    this.permissionsController = new PermissionsController(this.store);
  }

  render() {
    return (
      <Provider permissionsController={this.permissionsController}>
        <div className="p-5 text-2xl border-b border-gray-300 border-solid font-medium bg-white  ">Clients Permissions</div>
        <PermissionsContainer />
      </Provider>
    );
  }
}
